import type {
  ReactNode,
} from 'react';
import {
  createRoot,
  type Root,
} from 'react-dom/client';

import { getTheme } from '@n3/css-base';
import { ThemeProvider } from 'styled-components';

const removeContainer = (container: HTMLElement, root: Root): void => {
  setTimeout(() => {
    root.unmount();
    document.body.removeChild(container);
  });
};

type RenderComponentParams<ResultType> = {
  resolveModal: (payload: ResultType) => void;
};

type RenderComponent<ResultType> = (params: RenderComponentParams<ResultType>) => ReactNode;

export function showModal<
ResultType,
>(renderComponent: RenderComponent<ResultType>): Promise<ResultType> {
  const theme = getTheme();

  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const resolveModal = (payload: ResultType): void => {
      removeContainer(container, root);
      resolve(payload);
    };

    root.render(
      <ThemeProvider theme={theme}>
        {renderComponent({
          resolveModal,
        })}
      </ThemeProvider>,
    );
  });
}
